document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tabs li a");
  const panels = document.querySelectorAll(".help-center-right .panel");
  const currentUrl = window.location.pathname; // 获取当前页面的路径

  // 根据页面路径设置第一个激活的tab
  function setActiveTabByUrl(url) {
    const tabMapping = {
      "/pages/about-us": "#about_us",
      "/pages/contact-us": "#contact_us",
      "/pages/exchange-return-policy": "#refund_return",
      "/pages/ggjia-5-year-warranty-products": "#warranty",
      "/pages/shipping-policy": "#shipping_policy",
      "/pages/wholesale": "#wholesale",
      "/pages/lights-calculator": "#lights-calculator",
      "/pages/member-benefits": "#member-benefits",
    };

    let targetId = tabMapping[url];

    if (targetId) {
      const targetTab = document.querySelector(`a[href="${targetId}"]`);
      if (targetTab) {
        targetTab.classList.add("active");
        document.querySelector(targetId).style.display = "block";
        return;
      }
    }

    // 如果没有匹配的tab，默认显示第一个tab
    const defaultTab = document.querySelector(".tabs li a");
    if (defaultTab) {
      defaultTab.classList.add("active");
      const defaultPanel = document.querySelector(".help-center-right .panel");
      if (defaultPanel) {
        defaultPanel.style.display = "block";
      }
    }
  }

  setActiveTabByUrl(currentUrl);

  // 处理选项卡点击事件
  tabs.forEach((tab) => {
    tab.addEventListener("click", function (event) {
      const href = this.getAttribute("href");

      // 检查是否是外部链接
      const isExternal =
        href && (href.startsWith("http") || href.startsWith("https"));

      if (!isExternal) {
        // 阻止默认行为，处理面板切换
        event.preventDefault();
        // 移除所有 tab 的 active 类
        tabs.forEach((t) => {
          t.classList.remove("active");
        });

        // 给当前点击的 tab 添加 active 类
        this.classList.add("active");

        // 隐藏所有面板
        panels.forEach((panel) => {
          panel.style.display = "none";
        });

        // 显示对应的面板
        const targetPanel = document.querySelector(href);
        if (targetPanel) {
          targetPanel.style.display = "block";
        } else {
          console.log("Target panel not found:", href);
        }
      }
    });
  });
});
